export const getPageCount = (itemCount: number, itemsPerPage: number) =>
  Math.ceil(itemCount / itemsPerPage);
